// extracted by mini-css-extract-plugin
export default {"modal-style":"DisableDetailsModal_modal-style__hhMta","bold-dark-text":"DisableDetailsModal_bold-dark-text__WLHvH","thin-dark-text":"DisableDetailsModal_thin-dark-text__aP6PP"};